import logo from "../../assets/images/logo-light.png";
import mba from "../../assets/images/mba-member-badge.jpg";
import MapIcon from "@mui/icons-material/Map";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import classes from "./Footer.module.scss";

const Footer = () => {
  const year = new Date().getFullYear().toString();

  return (
    <footer className={classes["footer"]}>
      <div className={classes["footer-inner"]}>
        <div className={classes["brand-col"]}>
          <img
            className={classes["logo-img"]}
            src={logo}
            alt="Unified Building Group"
          />
          <p>
            Remedial building, restoration and construction services across NSW.
          </p>
        </div>

        <div className={classes["contact-card"]}>
          <div className={classes["badge-col"]}>
            <img src={mba} alt="Master Builders Association member badge" />
          </div>

          <div className={classes["contact-col"]}>
            <h3>Contact</h3>

            <p>
              <EmailIcon />
              <a href="mailto:Admin@unifiedbg.com.au">Admin@unifiedbg.com.au</a>
            </p>

            <p>
              <LocalPhoneIcon />
              <a href="tel:1800824000">1800 824 000</a>
            </p>

            <p>
              <MapIcon />
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.google.com/maps/dir//123+Epping+Rd+Macquarie+Park+NSW+2113/@-33.78406,151.1183696,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x6b12a7a9081591cf:0xcbd40c3940f109de"
              >
                Avaya House, Level 9, 123 Epping Rd, Macquarie Park, NSW 2113
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className={classes["bottom-bar"]}>
        <div>Unified Building Group © {year}</div>
        <div>Powered by Cliquenext Web Solutions</div>
      </div>
    </footer>
  );
};

export default Footer;
